import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
// import Home from './views/Home.vue';

Vue.use(Router);

// for public
const ifNotAuthenticated = (to, from, next) => {
  if (!store.getters.tokenscr) {
    next();
    return;
  } else {
    next('/home');
  }
};
// for user
const ifAuthenticated = (to, from, next) => {
  if (store.getters.tokenscr) {
    next();
    return;
  }
  next('/');
};
// for user
const ifAuthenticatedUser = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'mahasiswa') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/');
};
// for company
const ifAuthenticatedDosen = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'dosen') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/');
};
// for admin
const ifAuthenticatedAdmin = (to, from, next) => {
  if (store.getters.tokenscr) {
    if (store.getters.userrole === 'admin') {
      next();
      return;
    } else {
      next('/home');
    }
  }
  next('/');
};

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import('./views/Login.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/acronym',
      name: 'Acronym',
      component: () => import('./views/Acronym.vue'),
    },
    {
      path: '/funfact',
      name: 'Funfact',
      component: () => import('./views/Funfact.vue'),
    },
    {
      path: '/trend',
      name: 'Trend',
      component: () => import('./views/Trend.vue'),
    },
    {
      path: '/trivia',
      name: 'Trivia',
      component: () => import('./views/Trivia.vue'),
    },
    {
      path: '/exam',
      name: 'Test',
      component: () => import('./views/Test.vue'),
    },
    {
      path: '/favorite',
      name: 'Kamusfavorite',
      component: () => import('./views/Kamusfavorite.vue'),
    },
    {
      path: '/history',
      name: 'Kamushistory',
      component: () => import('./views/Kamushistory.vue'),
    },
    {
      path: '/kamus/detail',
      name: 'Kamusdetail',
      component: () => import('./views/Kamusdetail.vue'),
    },
    {
      path: '/admin/kamus',
      name: 'KamusAdmin',
      component: () => import('./views/admin/Kamus.vue'),
      beforeEnter: ifAuthenticatedAdmin,
    },
    {
      path: '/change-password',
      name: 'Changepassword',
      component: () => import('./views/Changepass.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/about',
      name: 'About',
      component: () => import('./views/About.vue'),
      beforeEnter: ifNotAuthenticated,
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('./views/Home.vue'),
      beforeEnter: ifAuthenticated,
    },
    {
      path: '/dosen/keputusan',
      name: 'SKDosen',
      component: () => import('./views/dosen/SK.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/tugas',
      name: 'STDosen',
      component: () => import('./views/dosen/ST.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/lainnya',
      name: 'SLDosen',
      component: () => import('./views/dosen/SL.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/sk-accunit/:kodesurat',
      name: 'SKUnitDetail',
      props: true,
      component: () => import('./views/dosen/SKUnitDetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/sk-accdir/:kodesurat',
      name: 'SKDirDetail',
      props: true,
      component: () => import('./views/dosen/SKDirDetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/st-accunit/:kodesurat',
      name: 'STUnitDetail',
      props: true,
      component: () => import('./views/dosen/STUnitDetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/st-accdir/:kodesurat',
      name: 'STDirDetail',
      props: true,
      component: () => import('./views/dosen/STDirDetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/sl-ver/:kodesurat',
      name: 'SLVerDetail',
      props: true,
      component: () => import('./views/dosen/SLVerDetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '/dosen/sl-acc/:kodesurat',
      name: 'SLAccDetail',
      props: true,
      component: () => import('./views/dosen/SLAccDetail.vue'),
      beforeEnter: ifAuthenticatedDosen,
    },
    {
      path: '*',
      name: 'Notfound',
      component: () => import('./views/Notfound.vue'),
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
});
